import * as React from 'react';
import ProjectCardAI from './ProjectCard';
import "../styles/projects.css";
import orange from "../images/orange.png";
import ai_therapist from "../images/ai-therapist-chatbot.png";
import lotus from "../images/lotus.png"
import prison_offense_vs_recidivism_within_3_years from "../images/prison_offense_vs_recidivism_within_3_years.png";

function AI() {

  return (
  	<div className="grid">
  	  <div className="pastprojects" style={{ backgroundColor: '#C3B1E1', width: '100%', height: '150px'}}>
  	    <h1 style={{ paddingTop: "4%", marginBottom: "10%" }}>Artificial Intelligence Projects</h1>
  	  </div>
		<div className="projectsGridRow1">
	    <ProjectCardAI link="/fruit-classification"
				     description="Fruit Classifier and Freshness Evaluator Model"
				     image1={orange}
		/>
  	    <ProjectCardAI link="/ai-therapist"
				     description="AI Therapist Chatbot"
				     image1={ai_therapist}
		/>
	  </div>
	  <div className="projectsGridRow2">
  	    <ProjectCardAI link="/criminal-justice-data-analysis"
				     description="Criminal Justice Data Analysis"
				     image1={prison_offense_vs_recidivism_within_3_years}
		/>
		<ProjectCardAI link="/wellness-support-agent"
				     description="Wellness Support Agent"
				     image1={lotus}
		/>
	  </div>
	</div>
  );
}

export default AI;
